package ru.it_mozaika.sender.js.application.frames.subscribers


import ru.it_mozaika.utils.checkResponseError
import io.ktor.client.call.*
import io.ktor.http.*
import js.core.jso
import kotlinx.browser.document
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.async
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import kotlinx.serialization.json.Json
import mui.material.*
import mui.system.responsive
import mui.system.sx
import oldcomponents.NotyType
import oldcomponents.showNotification
import react.*
import react.router.useNavigate
import ru.it_mozaika.components.*
import ru.it_mozaika.sender.common.models.*
import ru.it_mozaika.sender.js.application.components.StoresSelect
import ru.it_mozaika.sender.js.application.components.subscribers.addNewContactDialog
import ru.it_mozaika.sender.js.application.frames.MainCard
import tanstack.react.table.useReactTable
import tanstack.table.core.*
import mui.material.styles.Theme
import mui.material.styles.useTheme
import react.dom.aria.ariaLabel
import ru.it_mozaika.sender.js.application.components.subscribers.fieldSelectDialog
import ru.it_mozaika.sender.js.application.components.subscribers.subscriptionDialog
import ru.it_mozaika.sender.js.application.context.*
import web.cssom.*
import kotlinx.serialization.encodeToString
import mui.icons.material.CloudDownloadSharp
import mui.lab.LoadingButton
import mui.material.styles.TypographyVariant
import org.w3c.dom.events.KeyboardEvent
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import react.dom.aria.AriaRole
import react.dom.aria.ariaLabelledBy
import ru.it_mozaika.sender.js.application.*
import ru.it_mozaika.sender.js.application.components.TableSkeletonFrame
import ru.it_mozaika.sender.js.application.components.segments.RuleCompareTypeSelect
import ru.it_mozaika.sender.js.application.components.segments.RuleDateSelect
import tanstack.react.virtual.UseVirtualizerOptions
import tanstack.react.virtual.useVirtualizer
import web.html.HTMLDivElement
import kotlin.math.abs

private enum class BasicColumns(val colName: String, val ruTitle: String, val index: Int, val type: ColumnType) {
    Id("_id", "ID", 0, ColumnType.String),
    Email("email", "Почтовый адрес", 1, ColumnType.String),
    EmailVerified("emailVerified", "Email подтвержден", 2, ColumnType.Bool),
    Phone("phone", "Телефон", 3, ColumnType.String),
    PhoneVerified("phoneVerified", "Телефон подтвержден", 4, ColumnType.Bool),
    RegDate("regDate", "Дата регистрации", 5, ColumnType.Date),
    LastDelivery("lastDelivery", "Последнее получение", 6, ColumnType.Date),
    LastOpen("lastOpen", "Последнее открытие", 7, ColumnType.Date),
    Subscriptions("subscriptions", "Подписки", 8, ColumnType.String),
//    TableColumn("tags", "Тэги", 9),
}

val subscribersListFrame = VFC {
    val tableContext = useTable()
    val requestResultContext = useContext(RequestResultContext)
    val propertiesContext = useContext(PropertiesContext)
    val (subscribers, setSubscribers) = useState(listOf<SubscriberData>())
    val subscriptionContext = useContext(SubscriptionListContext)
    val backdrop = useContext(BackdropContext)
    val navigate = useNavigate()
    val storeContext = useContext(StoreContext)
    val theme = useTheme<Theme>()
    val currentStore = storeContext.currentStore
    val (rowsPerPage, setRowsPerPage) = useState(10)
    val (page, setPage) = useState(0)
    /**
     * Значение в поле поиска
     * */
    val (searchQuery, setSearchQuery) = useState("")
    val (size, setSize) = useState(0)

    val (showAddNewContactsDialog, setShowAddNewContactsDialog) = useState(false)
    val (showSubscribeDialog, setShowSubscribeDialog) = useState(false)
    val (showUnSubscribeDialog, setShowUnSubscribeDialog) = useState(false)
    var showPropertiesFilter by useState(false)
    var showFieldSelectDialog by useState(false)
    var showSubscriptionFilter by useState(false)
    var showSubscriberDateDialog by useState(false)
    var templateCreationInProcess by useState(false)

    var emailMessages by useState(listOf<EmailMessage>())
    var selectedFields by useState<List<String>>(listOf())
    val (tableColumns, setTableColumns) = useState(listOf<TableColumn>())
    val storage = kotlinx.browser.localStorage
    var columns by useState(listOf<TableColumn>())

    useEffect(currentStore?.id, columns){
        currentStore?.id?.let{
            if (!storage.getItem("${it}-subscribers-list-columns-order").isNullOrBlank()) {
                val encodedString = storage.getItem("${it}-subscribers-list-columns-order")
                val cols = try {
                    Json.decodeFromString<List<TableColumn>>(encodedString!!)
                } catch (e: Exception) {
                    listOf()
                }
                if (cols !== tableColumns) {
                    setTableColumns(cols)
                }
            } else {
                if (columns !== tableColumns) {
                    setTableColumns(columns)
                }
            }
        }
    }
    useEffect(currentStore?.id, columns){
        currentStore?.id?.let{
            if (!storage.getItem("${it}-subscribers-list-visible-columns").isNullOrBlank()) {
                val encodedString = storage.getItem("${it}-subscribers-list-visible-columns")
                val selected = try {
                    Json.decodeFromString<List<String>>(encodedString!!)
                } catch (e: Exception) {
                    listOf()
                }
                if (selected !== selectedFields) {
                    selectedFields = selected
                }
            } else {
                selectedFields = columns.map { it.name }
            }
        }
    }
    var selectedSubscribers by useState(listOf<SubscriberData>())
    useEffect(tableContext.selected) {
        selectedSubscribers = tableContext.selected.mapNotNull { id ->
            subscribers.find { it.id == id }
        }
    }

    useEffect(propertiesContext.propertiesList, currentStore) {
        val cols = BasicColumns.entries.map{
            TableColumn(it.colName, it.ruTitle, it.index, it.type)
        }.toMutableList()
        val properties = propertiesContext.propertiesList.mapIndexed { index, property ->
            TableColumn(
                property.id,
                property.name,
                (cols.size - 1) + index,
                when (property.type) {
                    PropertyType.String -> ColumnType.String
                    PropertyType.Int -> ColumnType.Int
                    PropertyType.Float -> ColumnType.Float
                    PropertyType.Date -> ColumnType.Date
                    PropertyType.Bool -> ColumnType.Bool
                }
            )
        }
        cols += properties
        columns = cols.toList()
    }
    val selectedColumns = useMemo(tableColumns, selectedFields) {
        if (selectedFields.isNotEmpty()) {
            tableColumns.filter { selectedFields.contains(it.name) }
        } else {
            tableColumns
        }
    }
    val table = useReactTable<SubscriberData>(
        options = jso {
            this.columns = useMemo(selectedColumns, subscriptionContext.lists) {
                selectedColumns.sortedBy { it.index }
                    .map { column ->
                        jso<ColumnDef<SubscriberData, Any?>> {
                            accessorFn = { sub, _ ->
                                when (column.name) {
                                    "_id" -> sub.id
                                    "email" -> sub.email
                                    "emailVerified" -> if (sub.emailVerified) "Да" else "Нет"
                                    "phone" -> sub.phone ?: "---"
                                    "phoneVerified" -> if (sub.phoneVerified) "Да" else "Нет"
                                    "regDate" -> sub.regDate?.toLocalString() ?: ""
                                    "lastDelivery" -> useMemo(emailMessages) {
                                        emailMessages.asSequence()
                                            .filter { it.subscriberData == sub.id && it.status == 5 }
                                            .map { it.events }
                                            .flatten()
                                            .filter { it is EmailMessageEvent.Delivery }
                                            .map { it.timestamp }
                                            .lastOrNull()?.toLocalString() ?: "---"
                                    }

                                    "lastOpen" -> useMemo(emailMessages) {
                                        emailMessages.asSequence()
                                            .filter { it.subscriberData == sub.id && it.status == 7 }
                                            .map { it.events }
                                            .flatten()
                                            .filter { it is EmailMessageEvent.Open }
                                            .map { it.timestamp }
                                            .lastOrNull()?.toLocalString() ?: "---"
                                    }

                                    "subscriptions" -> sub.subscriptions?.joinToString(",") ?: ""
                                    else -> {
                                        when (val property = sub.properties.find { it.propertyId == column.name }) {
                                            is SubscriberDataProperty.BoolProperty -> property.values.joinToString(", ")
                                            is SubscriberDataProperty.DateProperty -> property.values.map { it.toLocalString() }
                                                .joinToString(", ")

                                            is SubscriberDataProperty.FloatProperty -> property.values.joinToString(", ")
                                            is SubscriberDataProperty.IntProperty -> property.values.joinToString(", ")
                                            is SubscriberDataProperty.StringProperty -> property.values.joinToString(", ")
                                            null -> "---"
                                        }
                                    }
                                }
                            }
                            cell = ColumnDefTemplate { context ->
                                val columnId = context.column.id
                                val value = context.getValue().toString()
                                if (columnId == "subscriptions") {
                                    val subscriptions = value.split(",")
                                        .mapNotNull { sub -> subscriptionContext.lists.find { it.id == sub }?.name }
                                    if (value == "") {
                                        Box.create {
                                            +"---"
                                        }
                                    } else {
                                        if (subscriptions.size > 1) {
                                            Box.create {
                                                Stack {
                                                    direction = responsive(StackDirection.row)
                                                    spacing = responsive(2)
                                                    Chip {
                                                        label = ReactNode(subscriptions.firstOrNull() ?: "")
                                                    }
                                                    Tooltip {
                                                        title = ReactNode(
                                                            if (subscriptions.size == 2) {
                                                                subscriptions.lastOrNull() ?: ""
                                                            } else {
                                                                subscriptions.subList(1, subscriptions.size - 1)
                                                                    .joinToString(", ")
                                                            }
                                                        )
                                                        Chip {
                                                            label = ReactNode("+ ${subscriptions.size - 1}")
                                                        }
                                                    }
                                                }
                                            }
                                        } else {
                                            Chip.create {
                                                label = ReactNode(subscriptions.firstOrNull() ?: "")
                                            }
                                        }
                                    }
                                } else {
                                    Box.create {
                                        +value
                                    }
                                }
                            }
                            id = column.name
                            header = StringOrTemplateHeader(column.ruTitle)
                        }
                    }
            }.toTypedArray()
            this.data = useMemo(subscribers) { subscribers.toTypedArray() }
            this.getCoreRowModel = getCoreRowModel()
        }
    )

    fun loadEmailMessages() {
        Http.post(
            "/emails/message/list",
            query = mapOf("store" to storeContext.currentStoreId.orEmpty()),
            body = subscribers.map { it.id }) { response ->
            if (response.status == HttpStatusCode.OK) {
                emailMessages = response.body()
            } else {
                requestResultContext.handleRequestRespond(response)
            }
        }
    }

    fun getSubscribersSize() {
        backdrop.show()
        if (currentStore != null) {
            Http.post(
                "/subscribers/size",
                query = mapOf("store" to currentStore.id, "search" to searchQuery),
                body = Rule.RuleGroup(true, propertiesContext.currentRules.toList())
            ) { response ->
                response.checkResponseError()?.let {
                    showNotification(it, NotyType.Error)
                    return@post
                }
                setSize(response.body<Int>())
                backdrop.hide()
            }
        }
    }

    fun getSubscribers() {
        backdrop.show()
        if (currentStore != null) {
            Http.post(
                "/subscribers",
                query = mapOf(
                    "page" to (page).toString(),
                    "rows" to rowsPerPage.toString(),
                    "search" to searchQuery,
                    "store" to currentStore.id
                ),
                body = Rule.RuleGroup(true, propertiesContext.currentRules.toList()),
                callback = { response ->
                    response.checkResponseError()?.let {
                        showNotification(it, NotyType.Error)
                        return@post
                    }
                    val result = response.body<List<SubscriberData>>()
                    setSubscribers(result)
                    tableContext.setSelected(listOf())
                    backdrop.hide()
                })
        }
    }
    useEffect(
        rowsPerPage,
        page,
        currentStore,
        propertiesContext.currentRules
    ) {
        getSubscribers()
        getSubscribersSize()
    }
    useEffect(subscribers) {
        loadEmailMessages()
    }

    addNewContactDialog {
        this.onClose = {
            setShowAddNewContactsDialog(false)
        }
        this.isOpen = showAddNewContactsDialog
    }
    subscriptionDialog {
        this.isOpen = showSubscribeDialog || showUnSubscribeDialog
        onClose = {
            setShowSubscribeDialog(false)
            setShowUnSubscribeDialog(false)
        }
        subscribe = showSubscribeDialog
        this.subscribers = useMemo(selectedSubscribers) { selectedSubscribers }
        this.requestHandler = {
            getSubscribersSize()
            getSubscribers()
            setShowSubscribeDialog(false)
            setShowUnSubscribeDialog(false)
        }
    }
    fieldSelectDialog {
        isOpen = showFieldSelectDialog
        this.columns = useMemo(tableColumns) { tableColumns }
        primaryKey = listOf(
            BasicColumns.Id.colName,
            BasicColumns.Email.colName
        )
        this.selectedFields = selectedFields
        this.onClose = {
            showFieldSelectDialog = !showFieldSelectDialog
        }
        this.changeHandler = {
            selectedFields = it
            currentStore?.id?.let { storeId ->
                val encodedString = Json.encodeToString(it)
                storage.setItem("${storeId }-subscribers-list-visible-columns", encodedString)
            }
        }
        onSwapHandler = { list ->
            val fieldsWithNewOrder = list.mapNotNull { title ->
                columns.find { it.name == title }
            }
            setTableColumns(fieldsWithNewOrder)
            currentStore?.id?.let{  storeId ->
                val encodedString = Json.encodeToString(fieldsWithNewOrder)
                storage.setItem("${storeId}-subscribers-list-columns-order", encodedString)
            }
        }
    }
    propertiesFilter {
        isOpen = showPropertiesFilter
        onClose = {
            showPropertiesFilter = false
        }
    }
    subscriberDateCalendarDialog{
        isOpen = showSubscriberDateDialog
        onClose = {
            showSubscriberDateDialog = false
        }
    }
    subscriptionFilterDialog {
        isOpen = showSubscriptionFilter
        onClose = {
            showSubscriptionFilter = false
        }
    }
    MainCard {
        CardHeader {
            title = Stack.create {
                sx {
                    this.alignItems = AlignItems.center
                }
                this.direction = responsive(StackDirection.row)
                spacing = responsive(5)
                Typography {
                    variant = TypographyVariant.h2
                    +"Подписчики"
                }
                FormControl {
                    sx {
                        minWidth = 300.px
                    }
                    variant = FormControlVariant.outlined
                    color = FormControlColor.secondary
                    OutlinedInput {
                        placeholder = "Поиск по Email:"
                        color = InputBaseColor.secondary
                        id = "search-filed"
                        onChange = { event ->
                            val newValue = (event.target as? web.html.HTMLInputElement)?.value.orEmpty()
                            setSearchQuery(newValue.lowercase())
                        }
                        endAdornment = InputAdornment.create {
                            ariaLabel = ""
                            this.position = InputAdornmentPosition.end
                            mui.icons.material.SearchSharp {
                                color = SvgIconColor.secondary
                                onClick = {
                                    propertiesContext.toggleRule(
                                        Pair(
                                            "email",
                                            Rule.RuleGroup(
                                                false,
                                                listOf(
                                                    Rule.SubscriberProperty.StringDataRule(
                                                        "email",
                                                        CompareType.CONTAINS,
                                                        searchQuery
                                                    )
                                                )
                                            )
                                        )
                                    )
                                }
                            }
                            onMouseDown = {
                                it.preventDefault()
                            }
                        }
                        onKeyDown = {
                            val event = it.unsafeCast<KeyboardEvent>()
                            when (event.key.lowercase()) {
                                "enter" -> {
                                    propertiesContext.toggleRule(
                                        Pair(
                                            "email",
                                            Rule.RuleGroup(
                                                false,
                                                listOf(
                                                    Rule.SubscriberProperty.StringDataRule(
                                                        "email",
                                                        CompareType.CONTAINS,
                                                        searchQuery
                                                    )
                                                )
                                            )
                                        )
                                    )
                                }
                            }
                        }
                    }
                }
                StoresSelect()
            }
            action = Stack.create {
                this.direction = responsive(StackDirection.row)
                ariaLabel = "subscribers-button-group"
                asDynamic().spacing = 2
                sx {
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.center
                }

                LoadingButton {
                    color = ButtonColor.secondary
                    +"Скачать шаблон"
                    loading = templateCreationInProcess
                    startIcon = CloudDownloadSharp.create()
                    loadingIndicator = CircularProgress.create {
                        color = CircularProgressColor.secondary
                        this.hidden = !templateCreationInProcess
                    }

                    onClick = {
                        templateCreationInProcess = true
                        val builder = StringBuilder()
                        builder.append(columns.filter { it.name != "lastDelivery" && it.name != "lastOpen" }
                            .joinToString(";") { it.ruTitle }).append("\n")
                        if (currentStore != null) {
                            Http.post(
                                "/subscribers",
                                query = mapOf(
                                    "search" to searchQuery,
                                    "store" to currentStore.id
                                ),
                                body = Rule.RuleGroup(true, propertiesContext.currentRules.toList()),
                                callback = { response ->
                                    response.checkResponseError()?.let {
                                        showNotification(it, NotyType.Error)
                                        return@post
                                    }
                                    CoroutineScope(Dispatchers.Default).launch {
                                        val list = async {
                                            response.body<List<SubscriberData>>()
                                        }.await()
                                        list.forEach { sub ->
                                            val row =
                                                columns.filter { it.name != "lastDelivery" && it.name != "lastOpen" }
                                                    .map { column ->
                                                        when (column.name) {
                                                            "_id" -> sub.id
                                                            "email" -> sub.email
                                                            "emailVerified" -> if (sub.emailVerified) "Да" else "Нет"
                                                            "phone" -> sub.phone ?: "---"
                                                            "phoneVerified" -> if (sub.phoneVerified) "Да" else "Нет"
                                                            "regDate" -> sub.regDate?.toLocalString() ?: ""
                                                            "subscriptions" -> sub.subscriptions?.mapNotNull { id ->
                                                                subscriptionContext.lists.find { it.id == id }?.name
                                                            }?.joinToString(",") ?: ""

                                                            else -> {
                                                                when (val property =
                                                                    sub.properties.find { it.propertyId == column.name }) {
                                                                    is SubscriberDataProperty.BoolProperty -> property.values.joinToString(
                                                                        ", "
                                                                    )

                                                                    is SubscriberDataProperty.DateProperty -> property.values.joinToString(
                                                                        ", "
                                                                    ) { it.toLocalString() }

                                                                    is SubscriberDataProperty.FloatProperty -> property.values.joinToString(
                                                                        ", "
                                                                    )

                                                                    is SubscriberDataProperty.IntProperty -> property.values.joinToString(
                                                                        ", "
                                                                    )

                                                                    is SubscriberDataProperty.StringProperty -> property.values.joinToString(
                                                                        ", "
                                                                    )

                                                                    null -> "---"
                                                                }
                                                            }
                                                        }
                                                    }
                                            builder.append(row.joinToString(";")).append("\n")
                                        }
                                        val element = document.createElement("a")
                                        val blob = Blob(
                                            arrayOf("\ufeff", builder.toString()),
                                            jso { this.type = "text/plain;charset=utf-8" })
                                        element.setAttribute("href", URL.createObjectURL(blob))
                                        element.setAttribute(
                                            "download",
                                            "Подписчики_${Clock.System.now().toLocalString()}.csv"
                                        )
                                        document.body?.appendChild(element)
                                        element.asDynamic().click()
                                        document.body?.removeChild(element)
                                    }
                                    templateCreationInProcess = false
                                })
                        }
                    }
                }

                AvatarButton {
                    tooltipTitle = "Добавить подписчиков"
                    mui.icons.material.AddCircleOutlineSharp()
                    onClick = {
                        navigate("/subscribers/add")
                    }
                }
                AvatarButton {
                    tooltipTitle = "Управление полями"
                    mui.icons.material.SettingsSharp()
                    onClick = {
                        showFieldSelectDialog = true
                    }
                }
                AvatarButton {
                    tooltipTitle = "Отменить фильтры"
                    mui.icons.material.FilterAltOff {
                        sx {
                            if (propertiesContext.columnsFilters.isNotEmpty()) color = Color("#FF0000")
                        }
                    }
                    onClick = {
                        propertiesContext.clear()
                    }
                }
            }
        }
        TableSkeletonFrame {
            this.showFilter = true
            this.toolbarActions = Stack.create {
                this.direction = responsive(StackDirection.row)
                ariaLabel = "subscribers-table-button-group"
                asDynamic().spacing = 2
                sx {
                    this.width = 100.pct
                    border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.flexEnd
                }
                AvatarButton {
                    this.tooltipTitle = "Подписать"
                    mui.icons.material.HowToRegSharp()
                    onClick = {
                        setShowSubscribeDialog(true)
                    }
                }
                AvatarButton {
                    this.tooltipTitle = "Отписать"
                    mui.icons.material.UnsubscribeSharp()
                    onClick = {
                        setShowUnSubscribeDialog(true)
                    }
                    palettecolor = theme.palette.error
                }
            }
            this.table = table
            this.columnsWithFilter = useMemo(propertiesContext.columnsFilters) { propertiesContext.columnsFilters }
            this.onPropertySelect = { columnName ->
                val column = columns.find { it.name == columnName }
                propertiesContext.setCurrentColumn(column)
                column?.let {
                    if (propertiesContext.propertiesList.map { it.id }.contains(column.name)) {
                        when (column.type) {
                            ColumnType.String,
                            ColumnType.Int,
                            ColumnType.Float,
                            ColumnType.Bool -> {
                                showPropertiesFilter = true
                            }

                            ColumnType.Date,
                            ColumnType.DateTime -> {
                                showSubscriberDateDialog = true
                            }

                            ColumnType.Long,
                            ColumnType.Double,
                            ColumnType.UInt16,
                            ColumnType.UUID,
                            ColumnType.Byte,
                            ColumnType.IPv4,
                            ColumnType.String_Array -> {
                            }
                        }
                    } else {
                        BasicColumns.entries.find { base -> base.colName == it.name }?.let { col ->
                            when (col) {
                                BasicColumns.Id,
                                BasicColumns.Email,
                                BasicColumns.EmailVerified,
                                BasicColumns.Phone,
                                BasicColumns.PhoneVerified -> {
                                    showPropertiesFilter = true
                                }

                                BasicColumns.Subscriptions -> {
                                    showSubscriptionFilter = true
                                }

                                BasicColumns.RegDate -> {
                                    showSubscriberDateDialog = true
                                }

                                BasicColumns.LastDelivery,
                                BasicColumns.LastOpen -> {
                                }
                            }
                        }
                    }
                }
            }
            this.columnId = "_id"
            this.label = "subscribers"
            this.onDoubleClickHandler = {
                navigate("/subscribers/$it")
            }
        }
        TablePagination {
            this.page = page
            this.count = size
            this.onPageChange = { _, newPage ->
                setPage(newPage.toInt())
            }
            this.onRowsPerPageChange = { event ->
                setRowsPerPage(event.target.asDynamic().value as Int)
                setPage(0)
            }
            this.rowsPerPage = rowsPerPage
        }
    }
}

private external interface PropertiesFilterProps : Props {
    var isOpen: Boolean
    var onClose: () -> Unit
}

private val propertiesFilter = FC<PropertiesFilterProps> { props ->
    val propertiesContext = useSubscribersProperties()
    val requestResultContext = useContext(RequestResultContext)
    val backdrop = useContext(BackdropContext)
    val (selectedValues, setSelectedValues) = useState(listOf<String>())
    val (text, setText) = useState("")
    var compareType by useState(CompareType.EQUALS)
    val currentColumn = useMemo(propertiesContext.currentColumn) { propertiesContext.currentColumn }
    var values by useState(listOf<String>())
    val parentRef = useRef<HTMLDivElement>()

    val handleToggle: (String) -> Unit = { value ->
        setSelectedValues { currentList ->
            val currentIndex = currentList.indexOf(value)
            if (currentIndex == -1) currentList.plus(value) else currentList.minus(value)
        }
    }
    useEffect(compareType) {
        if (compareType == CompareType.IN_LIST) {
            currentColumn?.let { column ->
                if (propertiesContext.propertiesList.map { it.id }.contains(column.name)) {
                    backdrop.show()
                    Http.get(
                        "/subscribers/filter/property",
                        query = mapOf("id" to column.name),
                        callback = { response ->
                            if (response.status == HttpStatusCode.OK) {
                                values = response.body()
                                backdrop.hide()
                            } else {
                                backdrop.hide()
                                requestResultContext.handleRequestRespond(response)
                            }
                        }
                    )
                } else {
                    backdrop.show()
                    Http.get(
                        "/subscribers/filter/column",
                        query = mapOf("column" to column.name),
                        callback = { response ->
                            if (response.status == HttpStatusCode.OK) {
                                values = response.body()
                                backdrop.hide()
                            } else {
                                requestResultContext.handleRequestRespond(response)
                                backdrop.hide()
                            }
                        }
                    )
                }
            }
        }
    }
    val virtualList = useVirtualizer(
        jso<UseVirtualizerOptions<HTMLDivElement, HTMLDivElement>> {
            this.getScrollElement = useCallback(parentRef.current) { parentRef.current }
            this.estimateSize = { 35 }
            this.count = useMemo(values) { values.size }
        }
    )
    val handleSelectValues: () -> Unit = {
        currentColumn?.let { column ->
            val isNegative = compareType < 0
            val type = compareType * (if (isNegative) -1 else 1)
            when (type) {
                CompareType.IN_LIST -> {
                    val rule = if (isNegative) {
                        Rule.RuleGroup(
                            true,
                            when (column.type) {
                                ColumnType.String -> selectedValues.map { value ->
                                    Rule.Negative(
                                        Rule.SubscriberProperty.StringDataRule(
                                            column.name,
                                            CompareType.EQUALS,
                                            value
                                        )
                                    )
                                }

                                ColumnType.Int -> selectedValues.map { value ->
                                    Rule.Negative(
                                        Rule.SubscriberProperty.IntDataRule(
                                            column.name,
                                            CompareType.EQUALS,
                                            value.toInt()
                                        )
                                    )
                                }

                                ColumnType.Float -> selectedValues.map { value ->
                                    Rule.Negative(
                                        Rule.SubscriberProperty.FloatDataRule(
                                            column.name,
                                            CompareType.EQUALS,
                                            value.toFloat()
                                        )
                                    )
                                }

                                ColumnType.Bool -> selectedValues.map { value ->
                                    Rule.Negative(
                                        Rule.SubscriberProperty.BooleanDataRule(
                                            column.name,
                                            CompareType.EQUALS,
                                            value.toBoolean()
                                        )
                                    )
                                }

                                ColumnType.Date,
                                ColumnType.DateTime,
                                ColumnType.Double,
                                ColumnType.Long,
                                ColumnType.UInt16,
                                ColumnType.UUID,
                                ColumnType.Byte,
                                ColumnType.IPv4,
                                ColumnType.String_Array -> listOf()
                            }
                        )
                    } else {
                        Rule.RuleGroup(
                            false,
                            when (column.type) {
                                ColumnType.String -> selectedValues.map { value ->
                                    if (isNegative) {
                                        Rule.Negative(
                                            Rule.SubscriberProperty.StringDataRule(
                                                column.name,
                                                CompareType.EQUALS,
                                                value
                                            )
                                        )
                                    } else {
                                        Rule.SubscriberProperty.StringDataRule(
                                            column.name,
                                            CompareType.EQUALS,
                                            value
                                        )
                                    }
                                }

                                ColumnType.Int -> selectedValues.map { value ->
                                    if (isNegative) {
                                        Rule.Negative(
                                            Rule.SubscriberProperty.IntDataRule(
                                                column.name,
                                                CompareType.EQUALS,
                                                value.toInt()
                                            )
                                        )
                                    } else {
                                        Rule.SubscriberProperty.IntDataRule(
                                            column.name,
                                            CompareType.EQUALS,
                                            value.toInt()
                                        )
                                    }
                                }

                                ColumnType.Float -> selectedValues.map { value ->
                                    if (isNegative) {
                                        Rule.Negative(
                                            Rule.SubscriberProperty.FloatDataRule(
                                                column.name,
                                                CompareType.EQUALS,
                                                value.toFloat()
                                            )
                                        )
                                    } else {
                                        Rule.SubscriberProperty.FloatDataRule(
                                            column.name,
                                            CompareType.EQUALS,
                                            value.toFloat()
                                        )
                                    }
                                }

                                ColumnType.Bool -> selectedValues.map { value ->
                                    Rule.SubscriberProperty.BooleanDataRule(
                                        column.name,
                                        CompareType.EQUALS,
                                        value.toBoolean()
                                    )
                                }

                                ColumnType.Date,
                                ColumnType.DateTime,
                                ColumnType.Double,
                                ColumnType.Long,
                                ColumnType.UInt16,
                                ColumnType.UUID,
                                ColumnType.Byte,
                                ColumnType.IPv4,
                                ColumnType.String_Array -> listOf()
                            }
                        )
                    }
                    propertiesContext.toggleRule(Pair(column.name, rule))
                }

                else -> {
                    val rule = when (column.type) {
                        ColumnType.String -> listOf(
                            if (compareType < 0) {
                                Rule.Negative(
                                    Rule.SubscriberProperty.StringDataRule(
                                        column.name,
                                        type,
                                        text
                                    )
                                )
                            } else {
                                Rule.SubscriberProperty.StringDataRule(column.name, type, text)
                            }
                        )

                        ColumnType.Int -> listOf(
                            if (compareType < 0) {
                                Rule.Negative(
                                    Rule.SubscriberProperty.IntDataRule(
                                        column.name,
                                        type,
                                        text.toInt()
                                    )
                                )
                            } else {
                                Rule.SubscriberProperty.IntDataRule(column.name, type, text.toInt())
                            }
                        )

                        ColumnType.Float -> listOf(
                            if (compareType < 0) {
                                Rule.Negative(
                                    Rule.SubscriberProperty.FloatDataRule(
                                        column.name,
                                        type,
                                        text.toFloat()
                                    )
                                )
                            } else {
                                Rule.SubscriberProperty.FloatDataRule(
                                    column.name,
                                    type,
                                    text.toFloat()
                                )
                            }
                        )

                        ColumnType.Bool -> listOf(
                            Rule.SubscriberProperty.BooleanDataRule(
                                column.name,
                                type,
                                text.toBooleanStrict()
                            )
                        )

                        ColumnType.Date,
                        ColumnType.DateTime,
                        ColumnType.Double,
                        ColumnType.Long,
                        ColumnType.UInt16,
                        ColumnType.UUID,
                        ColumnType.Byte,
                        ColumnType.IPv4,
                        ColumnType.String_Array -> listOf()
                    }
                    propertiesContext.toggleRule(
                        Pair(
                            column.name,
                            Rule.RuleGroup(
                                false,
                                rule
                            )
                        )
                    )
                }
            }
        }
    }
    Dialog {
        sx {
            width = 100.pct
            marginTop = 56.px
        }
        open = props.isOpen
        asDynamic().maxWidth = "xl"
        DialogTitle {
            +if (compareType == CompareType.IN_LIST) "Выберите значения" else "Введите значение для отбора"
        }
        DialogContent {
            Stack {
                sx {
                    margin = 5.px
                    padding = 5.px
                    overflow = Overflow.hidden
                }
                direction = responsive(StackDirection.column)
                spacing = responsive(3)
                Stack {
                    direction = responsive(StackDirection.row)
                    spacing = responsive(2)
                    when (currentColumn?.type) {

                        ColumnType.String -> {
                            RuleCompareTypeSelect {
                                this.availableTypes = listOf(
                                    CompareType.EQUALS,
                                    CompareType.CONTAINS,
                                    CompareType.STARTS_WITH,
                                    CompareType.ENDS_WITH,
                                    CompareType.IN_LIST,
                                    CompareType.IS_FILLED,
                                )
                                this.value = compareType
                                this.onSelect = { type ->
                                    compareType = type
                                }
                            }
                            Grid {
                                item = true
                                sx {
                                    display =
                                        if (abs(compareType) != CompareType.IS_FILLED) Display.block else None.none
                                }
                                searchField {
                                    this.onSearchQueryChange = {
                                        setText(it)
                                    }
                                }
                            }
                        }

                        ColumnType.Int,
                        ColumnType.Float -> {
                            RuleCompareTypeSelect {
                                this.availableTypes = listOf(
                                    CompareType.EQUALS,
                                    CompareType.CONTAINS,
                                    CompareType.STARTS_WITH,
                                    CompareType.ENDS_WITH,
                                    CompareType.IN_LIST,
                                    CompareType.IS_FILLED
                                )
                                this.value = compareType
                                this.onSelect = { type ->
                                    compareType = type
                                }
                            }
                            Grid {
                                item = true
                                sx {
                                    if (abs(compareType) != CompareType.IS_FILLED) Display.block else None.none
                                }
                                searchField {
                                    this.onSearchQueryChange = {
                                        setText(it)
                                    }
                                }
                            }
                        }

                        ColumnType.Bool -> {
                            RuleCompareTypeSelect {
                                this.availableTypes = listOf(CompareType.EQUALS, CompareType.IS_FILLED)
                                this.value = compareType
                                this.onSelect = { type ->
                                    compareType = type
                                }
                            }
                            FormControl {
                                sx {
                                    display = if (abs(compareType) != CompareType.IS_FILLED) Display.block else None.none
                                }
                                Select {
                                    color = InputBaseColor.secondary
                                    value = text
                                    label = ReactNode("Значение")
                                    onChange = { e, _ ->
                                        val value = e.target.value
                                        setText(value)
                                    }
                                    MenuItem {
                                        this.value = "true"
                                        +"Да"
                                    }
                                    MenuItem {
                                        this.value = "false"
                                        +"Нет"
                                    }
                                }
                            }
                        }

                        else -> {}
                    }
                }
                TableContainer {
                    sx {
                        display = if (abs(compareType) == CompareType.IN_LIST) Display.block else None.none
                    }
                    ref = parentRef
                    Table {
                        stickyHeader = true
                        TableBody {
                            virtualList.getVirtualItems().forEachIndexed { index, item ->
                                val value = values[item.index]
                                val isSelected = selectedValues.contains(value)
                                TableRow {
                                    hover = true
                                    sx {
                                        cursor = Cursor.pointer
                                        this.height = item.size.px
                                        this.transform = translatey((item.start - index * item.size).px)
                                        "&:last-child td, &:last-child th" {
                                            border = Border(0.px, LineStyle.solid)
                                        }
                                    }
                                    key = value
                                    TableCell {
                                        padding = TableCellPadding.none
                                        role = AriaRole.checkbox
                                        key = value
                                        FormControl {
                                            Checkbox {
                                                checked = isSelected
                                                tabIndex = -1
                                                disableRipple = true
                                                inputProps = jso {
                                                    ariaLabelledBy = "filter-${item.key}"
                                                }
                                                onClick = {
                                                    it.preventDefault()
                                                    handleToggle(value)
                                                }
                                                color = CheckboxColor.secondary
                                            }
                                        }
                                    }
                                    TableCell {
                                        +value
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        DialogActions {
            Stack {
                sx {
                    maxHeight = 50.px
                }
                direction = responsive(StackDirection.row)
                asDynamic().spacing = 2
                Button {
                    startIcon = mui.icons.material.FilterAltOff.create()
                    color = ButtonColor.secondary
                    variant = ButtonVariant.contained
                    onClick = {
                        propertiesContext.currentColumn?.let {
                            propertiesContext.deleteRule(it.name)
                            setText("")
                            setSelectedValues(listOf())
                        }
                        props.onClose()
                    }
                    +"Очистить фильтр"
                }
                Button {
                    color = ButtonColor.secondary
                    variant = ButtonVariant.outlined
                    onClick = {
                        propertiesContext.currentColumn?.let {
                            handleSelectValues()
                        }
                        props.onClose()
                    }
                    +"Отобрать"
                }
                Button {
                    color = ButtonColor.error
                    variant = ButtonVariant.outlined
                    onClick = {
                        props.onClose()
                    }
                    +"Отмена"
                }
            }
        }
    }
}

private external interface CampaignsCalendarDialogProps : Props {
    var isOpen: Boolean
    var onClose: () -> Unit
}

private val campaignsCalendarDialog = FC<CampaignsCalendarDialogProps> { props ->
    val propertiesContext = useSubscribersProperties()
    val (actualRule, setRule) = useState(Rule.EmailCampaign())
    useEffect(propertiesContext.currentColumn?.name) {
        BasicColumns.values().find { it.colName == (propertiesContext.currentColumn?.name ?: "") }?.let { column ->
            when (column) {
                BasicColumns.Id,
                BasicColumns.Email,
                BasicColumns.EmailVerified,
                BasicColumns.Phone,
                BasicColumns.PhoneVerified,
                BasicColumns.RegDate,
                BasicColumns.Subscriptions -> {
                }

                BasicColumns.LastDelivery -> setRule {
                    it.copy(EmailMessageStatus.DELIVERY)
                }

                BasicColumns.LastOpen -> setRule {
                    it.copy(EmailMessageStatus.OPEN)
                }
            }
        }
    }
    Dialog {
        open = props.isOpen
        asDynamic().maxWidth = "xl"
        sx {
            width = 100.pct
            marginTop = 56.px
        }
        DialogTitle {
            +"Выберите даты"
        }
        DialogContent {
            Stack {
                sx {
                    padding = 10.px
                    alignItems = AlignItems.center
                }
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Grid {
                    item = true
                    RuleCompareTypeSelect {
                        this.availableTypes = listOf(
                            CompareType.UNKNOWN,
                            CompareType.EQUALS,
                            CompareType.LESS,
                            CompareType.LESS_EQUALS,
                            CompareType.GREATER_EQUALS,
                            CompareType.GREATER,
                            CompareType.IN_RANGE,
                            CompareType.IS_FILLED
                        )
                        this.value = actualRule.compareType
                        this.onSelect = { compareType ->
                            setRule {
                                val value2 = if (compareType == CompareType.IN_RANGE) {
                                    actualRule.value1
                                } else {
                                    null
                                }
                                it.copy(compareType = compareType, value2 = value2)
                            }
                        }
                    }
                }
                Grid {
                    item = true
                    RuleDateSelect {
                        this.value = actualRule.value1
                        this.onChange = { date ->
                            setRule {
                                it.copy(value1 = date)
                            }
                        }
                    }
                }
                Grid {
                    item = true
                    sx {
                        display = if (actualRule.value2 != null) Display.block else None.none
                    }
                    RuleDateSelect {
                        this.value = actualRule.value2
                        this.onChange = { date ->
                            setRule {
                                it.copy(value2 = date)
                            }
                        }
                    }
                }
            }
        }
        DialogActions {
            Stack {
                sx {
                    maxHeight = 50.px
                }
                direction = responsive(StackDirection.row)
                asDynamic().spacing = 2
                Button {
                    disabled = actualRule.compareType == CompareType.UNKNOWN || actualRule.value1 == null
                    color = ButtonColor.secondary
                    variant = ButtonVariant.outlined
                    onClick = {
                        propertiesContext.currentColumn?.let {
                            when (actualRule.compareType) {
                                CompareType.UNKNOWN -> {
                                    propertiesContext.deleteRule(it.name)
                                }

                                else -> propertiesContext.toggleRule(Pair(it.name, actualRule))
                            }
                        }
                        props.onClose()
                    }
                    +"Отобрать"
                }
                Button {
                    color = ButtonColor.error
                    variant = ButtonVariant.outlined
                    onClick = {
                        props.onClose()
                    }
                    +"Отмена"
                }
            }
        }
    }
}

private external interface SubscriberDateCalendarDialogProps : Props {
    var isOpen: Boolean
    var onClose: () -> Unit
}

private val subscriberDateCalendarDialog = FC<SubscriberDateCalendarDialogProps> { props ->
    val propertiesContext = useSubscribersProperties()
    val (rule: Rule, setRule) = useState<Rule>(
        Rule.SubscriberProperty.DateDataRule(fieldId = "", CompareType.EQUALS, Clock.System.now())
    )
    val actualRule = useMemo(rule) {
        if (rule is Rule.Negative) {
            rule.rule as Rule.SubscriberProperty.DateDataRule
        } else {
            rule as Rule.SubscriberProperty.DateDataRule
        }
    }
    useEffect(propertiesContext.currentColumn?.name) {
        propertiesContext.currentColumn?.name?.let { name ->
            setRule {
                if (it is Rule.Negative) {
                    (it.rule as Rule.SubscriberProperty.DateDataRule).copy(fieldId = name)
                } else {
                    (it as Rule.SubscriberProperty.DateDataRule).copy(fieldId = name)
                }
            }
        }
    }
    useEffect(rule) {
        println("CurrentRule - $rule")
    }
    Dialog {
        open = props.isOpen
        asDynamic().maxWidth = "xl"
        sx {
            width = 100.pct
            marginTop = 56.px
        }
        DialogTitle {
            +"Выберите даты"
        }
        DialogContent {
            Stack {
                sx {
                    padding = 10.px
                    alignItems = AlignItems.center
                }
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Grid {
                    item = true
                    RuleCompareTypeSelect {
                        this.availableTypes = listOf(
                            CompareType.EQUALS,
                            CompareType.LESS,
                            CompareType.LESS_EQUALS,
                            CompareType.GREATER_EQUALS,
                            CompareType.GREATER,
                            CompareType.IN_RANGE,
                            CompareType.IS_FILLED,
                        )
                        this.value = actualRule.compareType * if (rule is Rule.Negative) -1 else 1
                        this.onSelect = { compareType ->
//                            val isNegative = compareType < 0
//                            val type = compareType * if (rule is Rule.Negative) -1 else 1
//                            setRule {
//                                val value2 = if (compareType == CompareType.IN_RANGE) {
//                                    actualRule.value1
//                                } else {
//                                    null
//                                }
//                                if (isNegative) {
//                                    Rule.Negative(
//                                        (it as Rule.SubscriberProperty.DateDataRule).copy(compareType = type, value2 = value2)
//                                    )
//                                } else { (it as Rule.SubscriberProperty.DateDataRule).copy(compareType = type, value2 = value2) }
//                            }
                            setRule {
                                val value2 = if (compareType == CompareType.IN_RANGE) {
                                    actualRule.value1
                                } else {
                                    null
                                }
                                val isNegative = compareType < 0
                                val type = compareType * (if (isNegative) -1 else 1)
                                val resultRule =
                                    ((if (it is Rule.Negative) it.rule else it) as Rule.SubscriberProperty.DateDataRule).copy(
                                        compareType = type,
                                        value2 = value2
                                    )
                                if (isNegative) {
                                    Rule.Negative(
                                        resultRule
                                    )
                                } else {
                                    resultRule
                                }
                            }
                        }
                    }
                }
                Grid {
                    item = true
                    sx {
                        display = if (actualRule.compareType != CompareType.IS_FILLED) Display.block else None.none
                    }
                    RuleDateSelect {
                        this.value = actualRule.value1
                        this.onChange = { date ->
//                            setRule {
//                                (it as Rule.SubscriberProperty.DateDataRule).copy(value1 = date)
//                            }
                            setRule {
                                if (it is Rule.Negative) {
                                    it.copy((it.rule as Rule.SubscriberProperty.DateDataRule).copy(value1 = date))
                                } else {
                                    (it as Rule.SubscriberProperty.DateDataRule).copy(value1 = date)
                                }
                            }
                        }
                    }
                }
                Grid {
                    item = true
                    sx {
                        display = if (actualRule.value2 != null) Display.block else None.none
                    }
                    RuleDateSelect {
                        this.value = actualRule.value2
                        this.onChange = { date ->
//                            setRule {
//                                (it as Rule.SubscriberProperty.DateDataRule).copy(value2 = date)
//                            }
                            setRule {
                                if (it is Rule.Negative) {
                                    it.copy((it.rule as Rule.SubscriberProperty.DateDataRule).copy(value2 = date))
                                } else {
                                    (it as Rule.SubscriberProperty.DateDataRule).copy(value2 = date)
                                }
                            }
                        }
                    }
                }
            }
        }
        DialogActions {
            Stack {
                sx {
                    maxHeight = 50.px
                }
                direction = responsive(StackDirection.row)
                asDynamic().spacing = 2
                Button {
                    color = ButtonColor.secondary
                    variant = ButtonVariant.outlined
                    onClick = {
                        propertiesContext.currentColumn?.let {
                            propertiesContext.deleteRule(it.name)
                            setRule(
                                Rule.SubscriberProperty.DateDataRule(
                                    fieldId = "",
                                    CompareType.EQUALS,
                                    Clock.System.now()
                                )
                            )
                        }
                        props.onClose()
                    }
                    +"Очистить фильтр"
                }
                Button {
                    disabled = actualRule.fieldId.isBlank()
                    color = ButtonColor.secondary
                    variant = ButtonVariant.outlined
                    onClick = {
//                        println("subscriberDateCalendarDialog on accept click/ rule - $actualRule")
                        propertiesContext.currentColumn?.let { column ->
//                            if (actualRule.compareType == CompareType.IS_FILLED) {
//                                if (propertiesContext.propertiesList.map { it.id }.contains(column.name)) {
//                                    propertiesContext.toggleRule(
//                                        Pair(
//                                            column.name,
//                                            Rule.RuleGroup(
//                                                true,
//                                                listOf(
//                                                    Rule.SubscriberProperty.StringDataRule(
//                                                        column.name,
//                                                        CompareType.CompareType.IS_FILLED,
//                                                        column.name
//                                                    )
//                                                )
//                                            )
//                                        )
//                                    )
//                                } else {
//                                    propertiesContext.toggleRule(
//                                        Pair(
//                                            column.name, Rule.RuleGroup(
//                                                false,
//                                                listOf(
//                                                    Rule.SubscriberProperty.StringDataRule(
//                                                        column.name,
//                                                        CompareType.IS_NULL,
//                                                        column.name
//                                                    ),
//                                                    Rule.SubscriberProperty.StringDataRule(
//                                                        column.name,
//                                                        CompareType.NOT_EXIST,
//                                                        column.name
//                                                    ),
//                                                )
//                                            )
//                                        )
//                                    )
//                                }
//                            } else {
                            propertiesContext.toggleRule(
                                Pair(
                                    column.name,
                                    Rule.RuleGroup(true, listOf(rule))
                                )
                            )
//                            }
                        }
                        props.onClose()
                    }
                    +"Отобрать"
                }
                Button {
                    color = ButtonColor.error
                    variant = ButtonVariant.outlined
                    onClick = {
                        props.onClose()
                    }
                    +"Отмена"
                }
            }
        }
    }
}

private external interface SubscriptionFilter : Props {
    var isOpen: Boolean
    var onClose: () -> Unit
}

private val subscriptionFilterDialog = FC<SubscriptionFilter> { props ->
    val sublistContext = useSubscriptionLists()
    val propertiesContext = useSubscribersProperties()
    val (selected, setSelected) = useState<List<String>>(listOf())
    Dialog {
        sx {
            width = 100.pct
            marginTop = 56.px
        }
        open = props.isOpen
        asDynamic().maxWidth = "xl"
        DialogTitle {
            +"Фильтр по подпискам"
        }
        DialogContent {
            TableContainer {
                Table {
                    ariaLabel = "subscription-filter-table"
                    ariaLabelledBy = "subscription-filter-table-title"
                    stickyHeader = true
                    TableBody {
                        sublistContext.lists.forEach { sublist ->
                            TableRow {
                                sx {
                                    "&:last-child td, &:last-child th" {
                                        border = Border(0.px, LineStyle.solid)
                                    }
                                }
                                TableCell {
                                    FormControl {
                                        Checkbox {
                                            checked = selected.contains(sublist.id)
                                            onClick = {
                                                it.preventDefault()
                                                setSelected { current ->
                                                    if (current.contains(sublist.id)) current.minus(sublist.id) else current.plus(
                                                        sublist.id
                                                    )
                                                }
                                            }
                                            color = CheckboxColor.secondary
                                        }
                                    }
                                }
                                TableCell {
                                    +sublist.name
                                }
                            }
                        }

                    }
                }
            }
        }
        DialogActions {
            sx {
                alignItems = AlignItems.flexEnd
            }
            Stack {
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Button {
                    variant = ButtonVariant.contained
                    color = ButtonColor.secondary
                    onClick = {
                        propertiesContext.currentColumn?.let { column -> propertiesContext.deleteRule(column.name) }
                        setSelected(listOf())
                    }
                    +"Очистить фильтр"
                }
                Button {
                    disabled = selected.isEmpty()
                    color = ButtonColor.secondary
                    +"Отобрать по подпискам"
                    onClick = {
                        propertiesContext.currentColumn?.let { column ->
                            propertiesContext.toggleRule(
                                Pair(
                                    column.name,
                                    Rule.RuleGroup(false, selected.map { value ->
                                        Rule.SubscriberProperty.StringDataRule(column.name, CompareType.IN_LIST, value)
                                    })
                                )
                            )
                        }

                        props.onClose()
                    }
                    variant = ButtonVariant.contained
                }
                Button {
                    variant = ButtonVariant.outlined
                    +"Закрыть"
                    color = ButtonColor.error
                    onClick = {
                        props.onClose()
                    }
                }
            }
        }
    }
}

